/* @flow */

import * as React from 'react';
import { useCallback, useRef } from 'react';

import Localizer from '../../../helpers/localization';
import ButtonFX from '../../buttons/ButtonFX';
import { WidthKind } from '../../buttons/types';
import Modal, { ModalView } from '../modal';
import './AuthenticationRequiredModal.css';

const AuthenticationRequiredModal = (): React.Node => {
  const modalRef = useRef<ModalView | null>(null);

  const setModalRef = useCallback((instance: ModalView | null) => {
    modalRef.current = instance;
  }, []);

  const handleOnClick = useCallback(() => {
    modalRef.current?.close();
  }, []);

  return (
    <Modal
      ariaLabel={Localizer.localize('accessibility.modal.authentication_required')}
      canCloseOnEscape={false}
      canCloseOnOverlayClick={false}
      className='authenticationRequired'
      hasCloseButton={false}
      header={Localizer.localize('modal.authentication_required.title')}
      innerRef={setModalRef}
      isAlert
    >
      <div className='authenticationRequiredContent'>
        <div>{Localizer.localize('modal.authentication_required.message')}</div>
        <ButtonFX onClick={handleOnClick} widthKind={WidthKind.Stretched}>
          {Localizer.localize('common.actions.ok')}
        </ButtonFX>
      </div>
    </Modal>
  );
};

export default AuthenticationRequiredModal;
